/**
 * Addressbook CopilotKit Actions
 */

import { useCopilotAction } from '@copilotkit/react-core'
import { useDispatch } from '@spcc/core'
import { addressbookActions } from '../store/addressbook.slice'

export function useAddressbookActions() {
  const dispatch = useDispatch()

  useCopilotAction({
    name: 'filterAddressesByType',
    description: 'Filter addresses by type',
    parameters: [{ name: 'type', type: 'string', description: 'Type: site, office, warehouse, or all', required: true }],
    handler: async ({ type }) => { dispatch(addressbookActions.filterByType(type as 'site' | 'office' | 'warehouse' | 'all')); return `Filtered addresses to show ${type}` },
  })

  useCopilotAction({
    name: 'searchAddresses',
    description: 'Search addresses',
    parameters: [{ name: 'query', type: 'string', description: 'Search query', required: true }],
    handler: async ({ query }) => { dispatch(addressbookActions.searchAddresses(query)); return `Searching addresses for "${query}"` },
  })
}
